module.exports = __webpack_public_path__ + "img/login.38558c11.png";